import { render, staticRenderFns } from "./exitPrompt.vue?vue&type=template&id=0c924995&scoped=true&"
import script from "./exitPrompt.vue?vue&type=script&lang=js&"
export * from "./exitPrompt.vue?vue&type=script&lang=js&"
import style0 from "./exitPrompt.vue?vue&type=style&index=0&id=0c924995&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c924995",
  null
  
)

export default component.exports